export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Гібрид соняшнику НС-Х-6045 відноситься до категорії середньостиглих культур - він визріває протягом 111-114 днів. Рослина має потужне і сильно розгалужене коріння, що йде в грунт на глибину більше 2 м - завдяки цьому воно може видобувати вологу навіть у посушливі періоди. Стресостійкість НС-Х-6045 досить висока - він добре переносить різкі перепади температури та інші несприятливі погодні умови. Крім того, гібрид має стійкість до вилягання та осипання.
                </p>
                <p className="card__description-title">
                    Характеристики
                </p>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Генетичний потенціал врожайності</td>
                        <td className="card__description__th-index">58 ц/га</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Група стиглості</td>
                        <td className="card__description__th-index">111-114 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Тип</td>
                        <td className="card__description__th-index">Екстенсивний</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослини</td>
                        <td className="card__description__th-index">170-190 см</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність</td>
                        <td className="card__description__th-index">52-55%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Рекомендовані зони вирощування</td>
                        <td className="card__description__th-index">Степ, Лісостеп</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Стійкість до вовчка</td>
                        <td className="card__description__th-index">A-F</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Короткі дані
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія початкового росту: 7/10</li>
                    <li className="card__description-numbering">Посухостійкість: 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання: 8/10</li>
                    <li className="card__description-numbering">Толерантність до фомопсису: 10/10</li>
                    <li className="card__description-numbering">Толерантність до іржі: 9/10</li>
                </ol>
                <div className="card__description-title">Врожайність</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Дніпропетровська область, Криничанський район: 42 ц/га</li>
                    <li className="card__description-numbering">Кіровоградська область, Бобринецький район, 38 ц/га</li>
                    <li className="card__description-numbering">Миколаївська область, Первомайський район, 39 ц/га</li>
                    <li className="card__description-numbering">Одеська область, Кривоозерський район, 40 ц/га</li>
                    <li className="card__description-numbering">Херсонська область, Білозерський район, 27 ц/га</li>
                </ol>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
